module.exports = __webpack_public_path__ + "img/22.981a1857.png";